import { SkudBrskEndpoint } from '@/views/skud/shared/endpoint_services/skud-brsk-endpoint-service'

export class SkudBrskService {
  constructor () {
    this.endpoint = new SkudBrskEndpoint()
  }

  // -> {bound: Boolean} | null
  async getBinding (placeId) {
    return this.endpoint.getBrskBinding(placeId)
  }

  // -> {ok:true, data:{api_key_mask}} | {ok:false, error}
  async bindBrsk (placeId, apiKey) {
    return this.endpoint.bindBrsk(placeId, apiKey)
  }

  // -> {ok:true, data:{api_key_mask}} | {ok:false, error}
  async replaceApiKey (placeId, apiKey) {
    return this.endpoint.replaceApiKey(placeId, apiKey)
  }
}
